import { createFileRoute } from "@tanstack/react-router";
import { AutumnPointBackTemplate } from "~/features/autumnPointBack/AutumnPointBackTemplate";
import { userPreferencesQueryOptions } from "~/lib/queryOptions/userPreferences";

export const Route = createFileRoute("/_authenticated/autumn-point-back/")({
  // 好み診断が済んでいるかを、表示前に取得しておく（PICK UP のちらつきを防ぐ）
  loader: ({ context: { queryClient } }) =>
    queryClient.ensureQueryData(userPreferencesQueryOptions),
  component: AutumnPointBackTemplate,
});
